export const PHONE_VERIFICATION = 'PHONE_VERIFICATION'
export const PASSWORD_VERIFICATION = 'PASSWORD_VERIFICATION'
export const PHONE_CONFIRMATION = 'PHONE_CONFIRMATION'
